import { render, staticRenderFns } from "./DetailsBrandModal.vue?vue&type=template&id=2ec2f258&scoped=true"
import script from "./DetailsBrandModal.vue?vue&type=script&lang=ts"
export * from "./DetailsBrandModal.vue?vue&type=script&lang=ts"
import style0 from "./DetailsBrandModal.vue?vue&type=style&index=0&id=2ec2f258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec2f258",
  null
  
)

export default component.exports